import styled from '@emotion/styled';
import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

export interface BackdropLoadingProps {
    open: boolean;
}
type Props = BackdropLoadingProps;

const BackdropLoadingField = styled(Backdrop)(({ }) => ({
    zIndex: 1500,
    color: '#36d7b7',
}));

export const BackdropLoading: React.FC<Props> = (props: Props) => {
    const { open } = props;
    return (
        <>
            <BackdropLoadingField open={open}>
                <CircularProgress color="inherit" />
            </BackdropLoadingField>
        </>
    );
};
